/* eslint-disable @typescript-eslint/no-explicit-any */
import cx from "classnames";
/* eslint-disable jsx-a11y/no-onchange */
import React, { useState } from "react";

import { siteLocationPrefix } from "../../constants";
import { CrmEntity, EntityName } from "../../server/crm/dataService";
import * as styles from "./TestStyle.module.css";

type TestInputProps = Readonly<{
  contact?: CrmEntity<EntityName.contact>;
  account?: CrmEntity<EntityName.account>;
  onboardingHubProfile?: CrmEntity<EntityName.gaming_onboardinghubprofile>;
  onboarding?: CrmEntity<EntityName.gaming_onboarding>;
  pitch?: CrmEntity<EntityName.gaming_pitchprogram>;
}>;

export const TestCRMParameterSetter = ({
  contact,
  account,
  onboardingHubProfile,
  onboarding,
  pitch,
}: TestInputProps) => {
  const [selectedEntity, setSelectedEntity] = useState("");
  const [selectedParameter, setSelectedParameter] = useState("");
  const [selectedValue, setSelectedValue] = useState("");

  const onEntityChange = (event: any) => {
    setSelectedEntity(event.target.value);
  };
  const onParameterChange = (event: any) => {
    setSelectedParameter(event.target.value);
  };
  const onValueChange = (event: any) => {
    setSelectedValue(event.target.value);
  };

  const submit = () => {
    window.location.href = `${siteLocationPrefix}/test/setCrmParameter?entity=${selectedEntity}&parameter=${selectedParameter}&value=${selectedValue}`;
  };
  return (
    <div className={styles.crmParamSetterContainer}>
      CRM Parameter setter
      <div className={styles.container}>
        <p>Entity: </p>
        <select
          value={selectedEntity}
          onChange={onEntityChange}
          className={cx(styles.dropdown, styles.crmParamSetterInput2)}
        >
          {contact && <option value="contact">Contact</option>}
          {account && <option value="account">Account</option>}
          {onboardingHubProfile && (
            <option value="onboardingHubProfile">Onboarding Hub Profile</option>
          )}
          {onboarding && <option value="onboarding">Onboarding</option>}
          {pitch && <option value="pitch">Pitch</option>}
        </select>
      </div>
      <div className={styles.container}>
        <p>Parameter: </p>
        <input
          className={cx(styles.input, styles.crmParamSetterInput)}
          type="text"
          onChange={onParameterChange}
          required
        ></input>
      </div>
      <div className={styles.container}>
        <p>Value: </p>
        <input
          className={cx(styles.input, styles.crmParamSetterInput2)}
          type="text"
          onChange={onValueChange}
          required
        ></input>
      </div>
      <button
        className={styles.testButton}
        onClick={submit}
        disabled={!selectedEntity || !selectedParameter || !selectedValue}
      >
        Set parameter
      </button>
    </div>
  );
};
